angular.module('content.widgets.dcsWidget', [
  'content.widgets.DCSWidgetController'
])

/**
 * The dcsWidget provides a preview
 * of the dcsWidget item type
 *
 * @class DCSWidget
 * @constructor
 * @module content.widgets.dcsWidget
 * @example
 *   <dcs-widget
 *     model="form.model">
 *   </dcs-widget>
 */
.directive('dcsWidget', [
  '$state',
  function ($state) {
    'use strict';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        model: '='
      },
      templateUrl: function () {
        if ($state.params.widgetMode === 'edit' || $state.params.stateMode === 'edit') {
          return 'content/source/content/widgets/dcsWidget/dcs-widget-edit.html';
        }
        return 'content/source/content/widgets/dcsWidget/dcs-widget.html';
      },
      controller: 'DCSWidgetController'
    };
  }
]);
